import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { showMutationError } from "@/lib/mutation-error";
import { partnerApiService } from "@/services/partner-api.service";
import type { PartnerMemberRole } from "@/types/partner.types";

interface UpdateMemberRoleInput {
	memberId: string;
	role: PartnerMemberRole;
}

export const useUpdateMemberRole = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ memberId, role }: UpdateMemberRoleInput) =>
			partnerApiService.updateMemberRole(memberId, { role }),
		onSuccess: () => {
			toast.success("Role updated");
			queryClient.invalidateQueries({ queryKey: ["partner", "members"] });
		},
		onError: (err) => {
			showMutationError(err, "Failed to update role");
		},
	});
};
